var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8567 1.30787C6.03078 0.906426 6.60008 0.906426 6.77416 1.30787L7.89522 3.89314C7.96767 4.06022 8.12523 4.17469 8.30652 4.19196L11.1117 4.45927C11.5473 4.50077 11.7232 5.04221 11.3952 5.33182L9.28288 7.19691C9.14637 7.31744 9.08619 7.50266 9.12578 7.68042L9.73841 10.4309C9.83354 10.858 9.37296 11.1926 8.99617 10.9702L6.56963 9.53757C6.41281 9.44499 6.21805 9.44499 6.06123 9.53757L3.63469 10.9702C3.25789 11.1926 2.79732 10.858 2.89245 10.4309L3.50508 7.68042C3.54467 7.50266 3.48449 7.31744 3.34798 7.19691L1.23566 5.33182C0.907663 5.04221 1.08359 4.50077 1.51917 4.45927L4.32434 4.19196C4.50563 4.17469 4.66319 4.06022 4.73564 3.89314L5.8567 1.30787Z",
    stroke: "#455AFE",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.d9e746d5.svg";
export { ForwardRef as ReactComponent };